import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredRedeemFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.8601 7.51C15.6601 6.9 15.1201 6.5 14.5201 6.5H14.3201V5.79C14.3101 4.45 14.0601 3.6 13.4501 2.94C12.5101 2 11.1801 2 8.50005 2H5.82005C3.14005 2 1.81005 2 0.870051 2.94C-0.0599487 3.88 5.12517e-05 4.75 5.12517e-05 6.5V7.85C5.12517e-05 10.53 5.126e-05 11.88 0.940051 12.82C1.87005 13.76 3.22005 13.76 5.89005 13.76H7.53005C8.04005 14.09 8.66005 14.07 9.10005 13.69L10.6401 12.55L12.1801 13.69C12.8501 14.17 13.7101 14.03 14.1801 13.36C14.4501 12.96 14.5201 12.49 14.3801 12.08L13.7801 10.2L15.3901 9.05C15.9201 8.72 16.0601 8.11 15.8601 7.51ZM0.590051 6.49C0.590051 6.15 0.860051 5.94 1.13005 5.94H3.81005C4.14005 5.94 4.34005 6.14 4.34005 6.49C4.34005 6.82 4.07005 7.02 3.81005 7.02H1.13005C0.790051 7.02 0.590051 6.82 0.590051 6.49ZM5.82005 11.14H3.14005C2.81005 11.14 2.61005 10.94 2.61005 10.61C2.61005 10.28 2.88005 10.06 3.14005 10.06H5.82005C6.16005 10.06 6.36005 10.26 6.36005 10.61C6.36005 10.94 6.09005 11.14 5.82005 11.14ZM14.9401 8.34L13.0601 9.69C12.9401 9.82 12.8601 10.02 12.9401 10.16L13.6001 12.3C13.6701 12.57 13.6001 12.91 13.2701 12.97C13.1401 12.97 12.9401 12.97 12.8001 12.91L10.9901 11.57C10.8601 11.43 10.5901 11.43 10.4601 11.57L8.66005 12.91C8.38005 13.11 8.05005 13.05 7.92005 12.77C7.78005 12.64 7.78005 12.44 7.85005 12.3L8.58005 10.16C8.58005 9.95 8.58005 9.75 8.45005 9.69L6.58005 8.34C6.31005 8.13 6.31005 7.8 6.45005 7.6C6.58005 7.46 6.71005 7.4 6.91005 7.4H9.18005C9.39005 7.4 9.52005 7.26 9.59005 7.06L10.2601 4.91C10.3301 4.64 10.6601 4.44 10.9301 4.57C11.1301 4.57 11.1901 4.77 11.2601 4.91L11.9301 7.06C11.9301 7.26 12.1301 7.4 12.3301 7.4H14.6101C14.9401 7.4 15.1401 7.67 15.1401 7.93C15.1401 8.13 15.0701 8.21 14.9401 8.34Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredRedeemFilled)
const IconSvgColouredRedeemFilled = createIcon(
  ForwardRef,
  'SvgColouredRedeemFilled',
)
export default IconSvgColouredRedeemFilled
